import OrderConfirmation from "components/WebOrder/OrderConfirmation";
import {connect} from "react-redux";

const mapStateToProps = (state) => ({
    lastLoanNumber: state.webOrder.lastLoanNumber,
});

export default connect(mapStateToProps)(OrderConfirmation);
